import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const AMENITIES_LIST = "amenities_list";
export const CREATE_AMENITIES = "create_amenities";
export const UPDATE_AMENITIES = "update_amenities";
export const DELETE_AMENITIES = "delete_amenities";
export const GET_AMENITIES_DETAILS = "get_amenities_details";
export const AMENITIES_SIMPLE_LIST = "amenities_simple_details";
export const CLEAR_AMENITIES_ERRORS = "clearAmenityErrors";

// mutation types
export const SET_AMENITIES_ERROR = "setAmenityErrors";
export const REMOVE_AMENITIES_ERRORS = "removeAmenityErrors";

const state = {
    errors: null
};
const actions = {
    [AMENITIES_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/amenities?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_AMENITIES_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_AMENITIES_ERROR, response.errors);
                });
        });

    },
    [CREATE_AMENITIES](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createamenity", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_AMENITIES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_AMENITIES_ERROR, response.errors);
                });
        });
    },
    [UPDATE_AMENITIES](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updateamenity", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_AMENITIES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_AMENITIES_ERROR, response.errors);
                });
        });
    },
    [DELETE_AMENITIES](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deleteamenity", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_AMENITIES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_AMENITIES_ERROR, response.errors);
                });
        });
    },
    [GET_AMENITIES_DETAILS](context, id) {
            ApiService.setHeader();
            return new Promise(resolve => {
                ApiService.get("api/getamenitydetail", id)
                    .then(({data}) => {
                        if (data._metadata.outcomeCode === 0) {
                            resolve(data);
                        } else {
                            this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                            context.commit(SET_AMENITIES_ERROR, data.errors);
                        }
                    })
                    .catch(({response}) => {
                        context.commit(SET_AMENITIES_ERROR, response.errors);
                    });
            });
    },
    [CLEAR_AMENITIES_ERRORS](context) {
        context.commit(REMOVE_AMENITIES_ERRORS);
    },
    [AMENITIES_SIMPLE_LIST](context, payload) {
            ApiService.setHeader();
            return new Promise(resolve => {
                ApiService.datatable("api/amenitiessimple?type=" + payload.type)
                    .then(({data}) => {
                        if (data._metadata.outcomeCode === 0) {
                            resolve(data);
                        } else {
                            this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        }
                    }).catch(({response}) => {
                    context.commit(SET_AMENITIES_ERROR, response.errors);
                });
            });
    },
};

const mutations = {
    [SET_AMENITIES_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_AMENITIES_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
